import Vue from 'vue'
import Router from 'vue-router'
import { userlogin } from "@/api/attendance.js";
//登录
const login = () => import('@/pages/login/index')
//其他手机号登录
const otherLogin = () => import('@/pages/otherLogin/index')
//密码登录
const passwordLogin = () => import('@/pages/passwordLogin/index')
const home = () => import('@/pages/home/home')
//调度注册
const schedulingRegistration = () => import('@/pages/schedulingRegistration/index')
//司机注册
const driverRegistration = () => import('@/pages/driverRegistration/index')
//角色选择
const role = () => import('@/pages/role/index')
//订单列表
const orderList = () => import('@/pages/order/orderList')
//订单详情
const orderDetail = () => import('@/pages/order/orderDetail')
//评价
const evaluate = () => import('@/pages/evaluate/evaluate')
//我的
const my = () => import('@/pages/my/index')
//设置
const setUpPage = () => import('@/pages/setUpPage/index')
//黑名单
const blacklistPage = () => import('@/pages/blacklistPage/index')
//个人信息
const userInfoPage = () => import('@/pages/userInfoPage/index')
//银行卡列表
const BankCardList = () => import('@/pages/BankCardList/index')
//添加银行卡
const addBankCard = () => import('@/pages/addBankCard/index')
//更换手机号
const replacePhoneNumber = () => import('@/pages/replacePhoneNumber/index')
//设置密码
const administrator = () => import('@/pages/administrator/index')
//忘记密码
const forgotPassword = () => import('@/pages/forgotPassword/index')
const agreementPrivacy = () => import('@/pages/agreement/Privacy')
const agreementService = () => import('@/pages/agreement/Service')
Vue.use(Router)


let router = new Router({
  routes: [
    {
      path: '/',
      name: 'page',
      // redirect: '/guide-page',
      redirect: '/home',
    }, 
    {
      path: '/guide-page',
      name: 'guide-page',
      component: () => import('@/pages/home/guide-page')
    }, 
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        keepAlive: true
      }
    }, 
    {
      path: '/login',
      name: 'login',
      component: login
    }, {
      path: '/schedulingRegistration',
      name: 'schedulingRegistration',
      component: schedulingRegistration,
      meta: {
        keepAlive: true
      }
    }, {
      path: '/driverRegistration',
      name: 'driverRegistration',
      component: driverRegistration,
      meta: {
        keepAlive: true
      }
    },{
      path: '/my',
      name: 'my',
      component: my
    },{
      path: '/otherLogin',
      name: 'otherLogin',
      component: otherLogin,
      meta: {
        keepAlive: true
      }
    },{
      path: '/passwordLogin',
      name: 'passwordLogin',
      component: passwordLogin,
      meta: {
        keepAlive: true
      }

    },{
      path: '/role',
      name: 'role',
      component: role
    },{
      path: '/setUpPage',
      name: 'setUpPage',
      component: setUpPage
    },{
      path: '/blacklistPage',
      name: 'blacklistPage',
      component: blacklistPage
    },{
      path: '/userInfoPage',
      name: 'userInfoPage',
      component: userInfoPage
    },{
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta: {
        keepAlive: true
      }
    },{
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail
    },{
      path: '/evaluate',
      name: 'evaluate',
      component: evaluate
    },{
      path: '/BankCardList',
      name: 'BankCardList',
      component: BankCardList
    },{
      path: '/addBankCard',
      name: 'addBankCard',
      component: addBankCard
    },{
      path: '/replacePhoneNumber',
      name: 'replacePhoneNumber',
      component: replacePhoneNumber
    },{
      path: '/administrator',
      name: 'administrator',
      component: administrator
    },
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      component: forgotPassword
    },
    {
      path: '/agreementPrivacy',
      name: 'agreementPrivacy',
      component: agreementPrivacy
    },
    {
      path: '/agreementService',
      name: 'agreementService',
      component: agreementService
    },
    {
      path: '/standby/standby-list',
      component: () => import('@/pages/feature/standby/standby-list.vue'),
      meta: {title: '查询页面' }
    },
    {
      path: '/pay/order-pay',
      component: () => import('@/pages/feature/pay/order-pay'),
      meta: {title: '订单支付' }
    },
    {
      path: '/app/download',
      component: () => import('@/pages/feature/app/download'),
      meta: {title: '下载' }
    },
    {
      path: '/app/demo',
      component: () => import('@/pages/feature/app/demo'),
      meta: {title: 'demo' }
    },
    {
      path: '/app/share',
      component: () => import('@/pages/feature/app/share'),
      meta: {title: '分享' }
    },
    {
      path: '/app/poster',
      component: () => import('@/pages/feature/app/poster'),
      meta: {title: '分享' }
    },
    {
      path: '/app/nickname-edit',
      component: () => import('@/pages/feature/app/nickname-edit'),
      meta: {title: '昵称修改' }
    },
    {
      path: '/pay/pay-success',
      component: () => import('@/pages/feature/pay/pay-success.vue'),
      meta: {title: '支付结果' }
    },
    {
      path: '/driver/driver-list',
      component: () => import('@/pages/feature/driver/driver-list'),
      meta: {title: '推广司机' }
    },
    {
      path: '/driver/driver-map',
      component: () => import('@/pages/feature/driver/driver-map'),
      meta: {title: '司机详情' }
    },
    {
      path: '/agreement/agreement-list',
      component: () => import('@/pages/agreement/agreement-list'),
      meta: {title: '隐私管理' }
    },
    {
      path: '/agreement/:type',
      name: 'agreementDetail',
      component: () => import('@/pages/agreement/agreement-detail')
    },
    {
      path: '/driverRegistration/vip',
      name: 'vip',
      component: () => import('@/pages/driverRegistration/vip.vue')
    },
    {
      path: '/driverRegistration/equity',
      name: 'equity',
      component: () => import('@/pages/driverRegistration/equity.vue')
    },
    {
      path: '/home/select-location',
      component: () => import('@/pages/home/select-location'),
      meta: { title: '选择位置' }
    }
  ]
})
// 判断是否需要登录访问,
let isLoginRequired = routeName =>{
  let notLoginRoute = ['login'] // 无需登录即可访问的路由 name,
  const notLoginMark = {}
  // 构建标记对象
  if (Array.isArray(notLoginRoute)) {
    for (let i = 0; i < notLoginRoute.length; i += 1) {
      notLoginMark[notLoginRoute[i].toString()] = true
    }
  }
  notLoginRoute = null // 释放内存
  // 重写初始化函数
  isLoginRequired = name =>{
    if (!name) {
      return true
    }
    // 处理 Symbol 类型
    const target = typeof name === 'symbol' ? name.description : name
    return !notLoginMark[target]
  }
  return isLoginRequired(routeName)
}
router.beforeEach((to,from,next)=>{
  //判断是 需要登录验证的路由 且 未登录
  // let phone = localStorage.getItem('phone')
  // const logined = 
  // if (isLoginRequired(to.name) && !phone) {
  //   next({ path: '/login' })
  //   return
  // }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js